/* BRENSO Noir — interaction layer (loads deferred on every page) */
(function(){
  'use strict';
  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- scroll reveals ---- */
  function initReveals(){
    var els = document.querySelectorAll('.b-rv, [data-b-count]');
    if(!('IntersectionObserver' in window) || REDUCED){
      els.forEach(function(el){ el.classList.add('in'); if(el.hasAttribute('data-b-count')) el.textContent = el.getAttribute('data-b-count'); });
      return;
    }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(!e.isIntersecting) return;
        e.target.classList.add('in');
        if(e.target.hasAttribute('data-b-count')) count(e.target);
        io.unobserve(e.target);
      });
    }, {threshold:.2});
    els.forEach(function(el){ io.observe(el); });
  }
  function count(el){
    var end = parseInt(el.getAttribute('data-b-count'), 10) || 0, t0 = null;
    function step(ts){
      if(!t0) t0 = ts;
      var p = Math.min(1, (ts - t0) / 1600); p = 1 - Math.pow(1 - p, 3);
      el.textContent = Math.round(end * p);
      if(p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  /* ---- sticky showcase ---- */
  function initShowcase(){
    document.querySelectorAll('.b-show').forEach(function(sc){
      var steps = sc.querySelectorAll('.b-show__step');
      var phs = sc.querySelectorAll('.b-show__ph');
      var dots = sc.querySelectorAll('.b-show__dots i');
      var n = steps.length;
      if(!n) return;
      var idx = -1;
      function setStep(i){
        if(i === idx) return; idx = i;
        steps.forEach(function(s, j){ s.classList.toggle('on', j === i); });
        phs.forEach(function(p, j){ p.classList.toggle('on', j === i); });
        dots.forEach(function(d, j){ d.classList.toggle('on', j === i); });
      }
      setStep(0);
      if(REDUCED) return;
      function onScroll(){
        var r = sc.getBoundingClientRect();
        var total = r.height - window.innerHeight;
        if(total <= 0){ setStep(0); return; }
        var pr = Math.min(.999, Math.max(0, -r.top / total));
        setStep(Math.floor(pr * n));
      }
      window.addEventListener('scroll', onScroll, {passive:true});
      onScroll();
    });
  }

  /* ---- rotating quotes ---- */
  function initQuotes(){
    document.querySelectorAll('.b-quotes__stage').forEach(function(stage){
      var qs = stage.querySelectorAll('.b-quotes__q');
      if(qs.length < 2 || REDUCED) return;
      var i = 0;
      setInterval(function(){
        if(!document.body.contains(stage)) return;
        i = (i + 1) % qs.length;
        qs.forEach(function(q, j){ q.classList.toggle('on', j === i); });
      }, 4600);
    });
  }

  /* ---- intro cleanup: klasse verwijderen nadat de animatie klaar is ---- */
  function initIntro(){
    if(document.documentElement.classList.contains('b-intro')){
      setTimeout(function(){ document.documentElement.classList.remove('b-intro'); }, 2600);
    }
  }

  function boot(){ initReveals(); initShowcase(); initQuotes(); initIntro(); }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  /* re-run inside the Shopify theme editor when sections re-render */
  document.addEventListener('shopify:section:load', boot);
})();
